"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardAccesibility = void 0;
var react_1 = require("react");
var shared_1 = require("./shared");
var useKeyboardAccesibility = function (_a) {
    var currentValue = _a.currentValue, minDate = _a.minDate, maxDate = _a.maxDate, handleChange = _a.handleChange;
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        var focusedDate = currentValue || new Date();
        var newDate = new Date(focusedDate);
        var keyAdjustments = {
            ArrowUp: function () { return newDate.setDate(focusedDate.getDate() - 7); },
            ArrowDown: function () { return newDate.setDate(focusedDate.getDate() + 7); },
            ArrowLeft: function () { return newDate.setDate(focusedDate.getDate() - 1); },
            ArrowRight: function () { return newDate.setDate(focusedDate.getDate() + 1); },
            PageUp: function () {
                if (event.ctrlKey || event.metaKey) {
                    newDate.setFullYear(focusedDate.getFullYear() - 1);
                }
                else {
                    newDate.setMonth(focusedDate.getMonth() - 1);
                }
            },
            PageDown: function () {
                if (event.ctrlKey || event.metaKey) {
                    newDate.setFullYear(focusedDate.getFullYear() + 1);
                }
                else {
                    newDate.setMonth(focusedDate.getMonth() + 1);
                }
            },
            t: function () { return (newDate = new Date()); },
            T: function () { return (newDate = new Date()); },
        };
        if (!keyAdjustments[event.key]) {
            return;
        }
        keyAdjustments[event.key]();
        if (minDate && newDate < minDate) {
            newDate = new Date((0, shared_1.getDateFromDateOrNow)(minDate).setHours(0, 0, 0, 0));
        }
        if (maxDate && newDate > maxDate) {
            newDate = new Date((0, shared_1.getDateFromDateOrNow)(maxDate).setHours(0, 0, 0, 0));
        }
        handleChange && handleChange(newDate);
    }, [currentValue, handleChange, minDate, maxDate]);
    return {
        onKeyDown: onKeyDown,
    };
};
exports.useKeyboardAccesibility = useKeyboardAccesibility;
